module.exports = __webpack_public_path__ + "media/Video 123.fa538416.mp4";